import * as React from 'react';
import { Button } from "../button";
export var CheckboxIcon = function CheckboxIcon(_ref) {
  var size = _ref.size,
      _ref$checked = _ref.checked,
      checked = _ref$checked === void 0 ? false : _ref$checked,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$indeterminate = _ref.indeterminate,
      indeterminate = _ref$indeterminate === void 0 ? false : _ref$indeterminate,
      onClick = _ref.onClick,
      dataTestId = _ref['data-test-id'];
  var activeIcon = checked ? 'checkbox_filled' : 'checkbox_outline';
  var icon = indeterminate ? 'checkbox_indeterminate' : activeIcon;
  var palette = checked && !indeterminate ? 'primary' : 'neutral';
  return /*#__PURE__*/React.createElement(Button, {
    icon: icon,
    palette: palette,
    size: size,
    appearance: "icon",
    onClick: onClick,
    disabled: disabled || indeterminate,
    "data-test-id": dataTestId
  });
};